import styled from 'styled-components';

export const AddOn = styled.p<{}>`
  color: ${({ theme }) => theme.grayB8};
`;
